import { render, staticRenderFns } from "./UserWallOfLoveList.vue?vue&type=template&id=796660b8&scoped=true&"
import script from "./UserWallOfLoveList.vue?vue&type=script&lang=js&"
export * from "./UserWallOfLoveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796660b8",
  null
  
)

export default component.exports